import { render, staticRenderFns } from "./InfoMainCard.vue?vue&type=template&id=4f8ef25d&scoped=true&"
import script from "./InfoMainCard.vue?vue&type=script&lang=js&"
export * from "./InfoMainCard.vue?vue&type=script&lang=js&"
import style0 from "./InfoMainCard.vue?vue&type=style&index=0&id=4f8ef25d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8ef25d",
  null
  
)

export default component.exports